import EmptyModalContent from "@/components/atoms/modal-panels/EmptyModalContent";
import PredictiveLeadsIntro from "@/components/organisms/predictive/PredictiveLeadsIntro";

type Props = {
  onClose: () => void;
};

const PredictiveLeadsIntroModal = ({ onClose }: Props) => {
  return (
    <EmptyModalContent preventClose={false} onClose={onClose} padding={"none"}>
      <PredictiveLeadsIntro showCreateButton={false} />
    </EmptyModalContent>
  );
};

export default PredictiveLeadsIntroModal;
